export { default } from "./Strategies";
export { default as InheritedTag } from "./Components/InheritedTag";
